import classNames from 'classnames/bind';
import styles from './copyrightWarning.module.scss';

const cx = classNames.bind(styles);

const CopyrightWarning = () => {
  return (
    <div className={cx('copyrightWarning')}>
      <div className={cx('textWrap')}>
        <p className={cx('text')}>
          <span className={cx('emphasis')}>역검</span> 리포트(<span className={cx('emphasis')}>역검</span> 결과표)는
          잡다의 소유이며,
          <br />
          무단 재배포 시 법적 불이익을 받을 수 있습니다.
        </p>
      </div>
    </div>
  );
};

export default CopyrightWarning;
